"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _productSpecsRow = _interopRequireDefault(require("./product-specs-row"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
/**
 * Local Imports
 */

/**
 * ProductSpecs Component.
 * @module ProductSpecs
 *
 * @param {Object} props React props
 * @param {Array} props.sections Array of Sections (supports both rendered React components and plain objects)
 * @param {String} props.verticalMargin Vertical Spacing value
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @returns {React.ReactElement} ProductSpecs Component
 * @public
 */

function ProductSpecs({
  sections,
  verticalMargin = 'none',
  verticalPadding = 'none'
}) {
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: "product-specs-section",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, sections?.map((section, idx) => {
    return /*#__PURE__*/_react.default.isValidElement(section) ? section : /*#__PURE__*/_react.default.createElement(_productSpecsRow.default, (0, _extends2.default)({
      key: idx
    }, section));
  }));
}
var _default = exports.default = ProductSpecs;
ProductSpecs.propTypes = {
  sections: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};